<template>
  <v-app>
    <v-app-bar
      v-if="isTokenSet"
      color="primary"
    >
      <v-app-bar-title class="text-no-wrap">
        <div class="no-truncate">
          <img
            :src="logoPath"
            alt="BC Whales Logo"
            class="appbar-vertical-align logo"
          >
          <!--<humpback-logo class="appbar-vertical-align" />-->
          <span class="pl-5 text-h6 text-white site-title appbar-vertical-align">Database Portal</span>
        </div>
      </v-app-bar-title>
      <v-spacer />
      <div class="text pr-4">
        {{ username }}
      </div>
      <v-btn @click="logout">
        Logout
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-if="isTokenSet"
      permanent
    >
      <v-list
        density="compact"
        nav
        class="mt-4"
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.path"
          :prepend-icon="item.icon"
        >
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="ma-4">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import HumpbackLogo from "@/components/svgs/HumpbackLogo"

export default {
  components: {
    // HumpbackLogo
  },
  data: () => {
    const baseItems = [
      {
        title: "Sightings",
        icon: "mdi-calendar-check",
        path: "/sightings",
      },
      {
        title: "Whales",
        icon: "mdi-table",
        path: "/whales",
      },
      {
        title: "Photos",
        icon: "mdi-camera",
        path: "/photos",
      },
      {
        title: "Dashboard",
        icon: "mdi-map-marker",
        path: "/dashboard",
      }
    ];
    const adminItems = baseItems.concat([
      // { title: "Dashboard", icon: "mdi-view-dashboard-variant", path: "/dashboard"},
      { title: "Users", icon: "mdi-shield-account", path: "/users" },
      { title: "Data Quality", icon: "mdi-clipboard-check-outline", path: "/quality" },
    ])
    return {
      user: {},
      logoPath: "/BC_Whales_Logo_White_Primary.png",
      adminItems: adminItems,
      staffItems: baseItems,
    };
  },
  computed: {
    ...mapGetters({
      isTokenSet: "auth/isTokenSet",
      role: "auth/role",
      userDetails: "users/userDetails",
      username: "auth/username",
      token: "auth/token",
    }),
    items() {
      if (this.role && this.role === "admin") {
        // Logged in with what is apparently an admin role so show the admin items which should work for this user
        return this.adminItems;
      }
      // Otherwise, just show the user items - hide the admin items as they will be unusable for this user
      return this.staffItems;
    },
  },
  created() {
    this.getCurrentUser()
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
      getCurrentUser: "users/getCurrentUser",
      clearToken: "auth/clearToken",
    }),
  },
};
</script>

<style>

#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.no-truncate {
  overflow: visible;
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}
.site-title {
  overflow: visible;
  display: inline-block;
  padding-left: 2rem;
}
.appbar-vertical-align {
  vertical-align: middle;
}
.text {
  color: white;
  font-size: 17px;
  text-align: left;
}
.logo {
  height: 4rem;
  width: auto;
}
/* Center each column's header label and its values so the header sits
   directly over the value. Keyed off the cell-level classes so it applies to
   both v-data-table and v-data-table-server. */
.v-data-table__th,
.v-data-table__td {
  text-align: center !important;
}
.v-data-table__th .v-data-table-header__content {
  position: relative;
  width: 100%;
  justify-content: center !important;
}
/* Pull the sort arrow out of flow so it doesn't nudge the label off-centre. */
.v-data-table__th .v-data-table-header__sort-icon {
  position: absolute;
  right: 0;
}
</style>
